import { useTheme } from '@mui/material';
import DSBox from '../../../../design-system/DSBox';
import { DSTypography } from '../../../../design-system/Typography';
import { ReactComponent as CollectionKlydosNumberIcon } from '../../../../design-system/Icons/CollectionKlydosNumberIcon.svg';
import { ReactComponent as ChimeIcon } from '../../../../design-system/Icons/ChimeIcon.svg';
import { ReactComponent as SoundIcon } from '../../../../design-system/Icons/soundIcon.svg';
import { ReactComponent as ThirteenPluseIcon } from '../../../../design-system/Icons/13PluseIcon.svg';
import { ReactComponent as PSFIcon } from '../../../../design-system/Icons/PhotoSensitiveIcon.svg';
import { ReactComponent as ReminderIcon } from '../../../../design-system/Icons/reminder.svg';

export type CollectionMetadataProps = {
  klydoCount: number;
  hasChime?: boolean;
  hasSound?: boolean;
  hasThirteenPlusTag?: boolean;
  hasPSFTag?: boolean;
  hasReminder?: boolean;
};

const CollectionMetadata = ({
  klydoCount,
  hasChime,
  hasSound,
  hasThirteenPlusTag,
  hasPSFTag,
  hasReminder,
}: CollectionMetadataProps) => {
  const { spacing } = useTheme();

  return (
    <DSBox
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: spacing(4),
        alignItems: 'center',
      }}
    >
      <DSBox
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: spacing(1),
          alignItems: 'center',
        }}
      >
        <CollectionKlydosNumberIcon
          style={{
            fill: '#FFFFFF',
          }}
        />
        <DSTypography variant="body1" sx={{ color: '#FFFFFF' }}>
          {klydoCount} Klydos
        </DSTypography>
      </DSBox>

      {hasChime && (
        <DSBox
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: spacing(1),
            alignItems: 'center',
          }}
        >
          <ChimeIcon
            style={{
              fill: '#FFFFFF',
            }}
          />
          <DSTypography variant="body1" sx={{ color: '#FFFFFF' }}>
            Chime
          </DSTypography>
        </DSBox>
      )}

      {hasSound && (
        <DSBox
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: spacing(1),
            alignItems: 'center',
          }}
        >
          <SoundIcon
            style={{
              fill: '#FFFFFF',
            }}
          />
          <DSTypography variant="body1" sx={{ color: '#FFFFFF' }}>
            Sound
          </DSTypography>
        </DSBox>
      )}
      {hasThirteenPlusTag && (
        <DSBox
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: spacing(1),
            alignItems: 'center',
          }}
        >
          <ThirteenPluseIcon
            style={{
              fill: '#FFFFFF',
            }}
          />
          <DSTypography variant="body1" sx={{ color: '#FFFFFF' }}>
            Content
          </DSTypography>
        </DSBox>
      )}
      {hasPSFTag && (
        <DSBox
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: spacing(1),
            alignItems: 'center',
          }}
        >
          <PSFIcon
            style={{
              fill: '#FFFFFF',
            }}
          />
          <DSTypography variant="body1" sx={{ color: '#FFFFFF' }}>
            Photo Sensitive
          </DSTypography>
        </DSBox>
      )}
      {hasReminder && (
        <DSBox
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: spacing(1),
            alignItems: 'center',
          }}
        >
          <ReminderIcon
            style={{
              fill: '#FFFFFF',
            }}
          />
          <DSTypography variant="body1" sx={{ color: '#FFFFFF' }}>
            Reminder
          </DSTypography>
        </DSBox>
      )}
    </DSBox>
  );
};

export default CollectionMetadata;
